import { GridContainer } from 'libs/ui';
import { Category } from 'grids/category/category';

export const CategoryWrapper = (props) => {
  return (
    <GridContainer>
      <Category {...props} />
    </GridContainer>
  );
};
